/**
 * 地址合理性檢核
 * @param  {String}} value - input value
 * @return {Array} error msg
 */
function checkAddress(value) {
    // var $this = this,
    // value = $this.getMcuVal();
    const result = {
        success: false,
        msg: [],
        data: value,
    };
    value = value.slice(0);
    // value = value.slice(1).join('');
    value = HalfshapeToFullshape(value);
    if (value.trim() !== '') {
        // 有值
        // var address = $.trim(value);
        var address = value.trim();
        var addressFlag = 'N'; // 20110825，N:表住址裡面"沒有區"，Y:表住址裡面"<有區>且<區在號的後面>"
        var chineseNumberReg = /[一二三四五六七八九十壹貳參肆伍陸柒捌玖拾]/gi;
        var dashReg = /[/\-－]/gi;
        // dashReg = /[\-－]/gi;
        // numberReg = /[0-9０-９]/gi,
        // englishReg = /[a-zA-Zａ-ｚＡ-Ｚ]/gi
        var mapping = [
            '縣',
            '市',
            '鄉',
            '鎮',
            '區',
            '村',
            '里',
            '鄰',
            '路',
            '段',
            '街',
            '巷',
            '弄',
            '衖',
            '號',
            '棟',
            '樓',
            '室',
            'ｆ',
            'Ｆ',
        ];
        var data = [
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
        ];
        // _lastIndex = -1
        // ,numbermap = [
        //     '一',
        //     '二',
        //     '三',
        //     '四',
        //     '五',
        //     '六',
        //     '七',
        //     '八',
        //     '九',
        //     '十',
        //     '1',
        //     '2',
        //     '3',
        //     '4',
        //     '5',
        //     '6',
        //     '7',
        //     '8',
        //     '9',
        //     '10',
        //     '１',
        //     '２',
        //     '３',
        //     '４',
        //     '５',
        //     '６',
        //     '７',
        //     '８',
        //     '９',
        //     '１０',
        // ];
        var aNum = '0123456789０１２３４５６７８９';
        var cNum1 = '一二三四五六七八九十';
        // var c_num_2 = '壹貳參肆伍陸柒捌玖拾';
        address = address.toUpperCase();
        // 20110825-<有區>且<區在號的後面>
        if (
            address.indexOf('區') > 0 &&
            address.indexOf('區') > address.indexOf('號')
        ) {
            addressFlag = 'Y';
        }
        // let _lastIndex = -1;
        for (let i = 0, j = mapping.length; i < j; i++) {
            const _w = mapping[i];
            // 20110825
            // 因為住址有可能會有：民生東路二段279號12樓"A區"，<有區>且<區在號的後面>，這樣另外的情況發生，所以在檢核住址的部分要避開
            let _tmp;
            if (addressFlag === 'Y' && mapping[i] === '區') {
                _tmp = address.split('_');
            } else {
                _tmp = address.split(_w);
            }

            if (_tmp.length >= 2) {
                if (_w === '鎮' && _tmp[0] === '前鎮') continue;
                data[i] = _tmp[0] + _w;
                address = address.substring(data[i].length);
                if (i >= 14 && address.charAt('0') === '之') {
                    data[i] += address.substring(0, 2);
                    address = address.substring(2);
                }
                // _lastIndex = i;
            }

            if (address.length <= 0) break;
        }

        // 1. 不可有特殊符號【<】 【>】 【/】 【\】【：】【*】 【?】 【,】 【~】 【+】 【..】【$】 【#】【@】 【!】【%】 【&】【廿】 【卅】
        // value.search(/[＜＞／＼：＊？，～＋＄＃＠！％＆廿卅 ]/gi) > -1 ||

        if (value.search(/[廿卅/g]/gi) > -1) {
            result.msg.push('地址請勿使用文字【廿】或【卅】');
        }
        // 基本的emoji過濾
        const Emoji = /(\p{Emoji}\uFE0F|\p{Emoji_Presentation})/gu;
        if (value.search(Emoji) > -1 || value.indexOf('．．') > -1) {
            result.msg.push('地址請勿使用特殊符號');
        }
        // const chEn = /^[^0-9-\u4e00-\u9fa5]+$/;
        // if (value.search(chEn) > -1) {
        //     // if (value.search(/\p{sc=Han}/gu) > -1 || value.indexOf('．．') > -1) {
        //     result.msg.push('地址請勿使用特殊符號2');
        // }
        if (value.search(/[＜＞／＼：＊？，～＋＄＃＠！％＆&｛｝（）‘’。☻☺☹/(\s*$)/g]/gi) > -1) {
            result.msg.push('地址請勿填入空白或特殊符號或半形文字');
        }
        // 2. 前一個字不可為【0】~【9】(包含全形和半形)
        for (let i = 0; i < 11; i++) {
            if (i === 7) continue;
            if (data[i].length <= 1) continue;
            var ch = data[i].substr(data[i].length - 2, 1);
            if (aNum.indexOf(ch) > -1) {
                result.msg.push(mapping[i] + '的名稱不可含【0】~【9】');
            }
        }
        // 段後面每個字皆不可為【一】~【十】及【壹】~【拾】，但於”號”或”樓”之後，就不檢核
        if (data[9] !== '') {
            for (let i = 10; i < 15; i++) {
                if (i !== 13 && data[i].search(chineseNumberReg) > -1) {
                    result.msg.push('地址的路段後面數字請使用阿拉伯數字');
                    break;
                }
            }
        }
        // 3. 前一個字不可為【一】~【十】
        if (data[7].length > 1) {
            // 鄰
            const ch = data[7].substr(data[7].length - 2, 1);
            if (cNum1.indexOf(ch) > -1) {
                result.msg.push(
                    mapping[7] + '的名稱不可含【一】~【十】'
                );
            }
        }
        for (let i = 11; i < 15; i++) {
            // '巷', '弄', '衖', '號'
            if (data[i].length <= 1) continue;
            const ch = data[i].substr(data[i].length - 2, 1);
            if (i === 11) {
                // 針對巷檢核修正
                var cp = data[i].substr(0, data[i].length - 1);
                if (
                    cp === '三山一' ||
                    cp === '三山二' ||
                    cp === '三山三' ||
                    cp === '三山四'
                ) {
                    continue;
                }
            }

            if (cNum1.indexOf(ch) > -1) {
                // result.msg += $.format(
                //     '[{0}]的名稱不可含【一】~【十】！\n',
                //     mapping[i]
                // );
                // result.msg +=
                //     '[' +
                //     mapping[i] +
                //     ']的名稱不可含【一】~【十】！\n';
                result.msg.push(
                    mapping[i] + '的名稱不可含【一】~【十】'
                );
            }
        }
        // 5. 有"弄"才可有"衖"
        if (data[12] === '' && data[13] !== '') {
            // result.msg += '地址裡需有【弄】才可有【衖】！！\n';
            result.msg.push('地址裡需有【弄】才可有【衖】');
        }
        if (data[16].length > 1) {
            // 樓
            const ch = data[16].substr(data[16].length - 2, 1);
            if (cNum1.indexOf(ch) > -1) {
                result.msg.push(
                    mapping[16] + '的名稱不可含【一】~【十】'
                );
            }
        }

        // 6. 不可為接半形或全形的『-』『－』
        for (let i = 14; i < 16; i++) {
            if (data[i].search(dashReg) > -1) {
                result.msg.push(mapping[i] + '不得包含半形或全形的"-"');
            }
        }

        // 7 檢查樓層

        const _f1 = value.search('ｆ');
        const _f2 = value.search('Ｆ');
        const _f3 = value.search('f');
        const _f4 = value.search('F');
        const _f = value.split(/[ｆＦfF]/);
        if (_f.length > 1 || _f1 > 0 || _f2 > 0 || _f3 > 0 || _f4 > 0) {
            const ch = _f[0].substr(_f[0].length - 1);
            if (cNum1.indexOf(ch) > -1 || aNum.indexOf(ch) > -1) {
                // 【F】前一個字不可為【一】~【十】或【1】~【0】(包含全形和半形)
                // result.msg +=
                // '地址【F】前一字不可為【一】~【十】或【1】~【0】。樓層請用『樓』字！\n';
                result.msg.push('樓層請使用『樓』字');
            } else if (data[18] !== '' || data[19] !== '') {
                // 表示樓層者，一律使用【樓】，不使用【F】
                result.msg.push(
                    '地址【F】前一字不可為【一】~【十】或【1】~【0】'
                );
            } else {
                // F之後不可接”之”、”－“或空白。
                for (let i = 1; i < _f.length; i++) {
                    // if (_f[i].search(/\s|[\-－之]/gi) > -1) {
                    if (_f[i].search(/\s|[/\-－之 /(\s*$)/g]/gi) > -1) {
                        result.msg.push(
                            '地址【F】前一字不可為【一~十】或【1】~【0】。樓層請用『樓』字'
                        );
                        break;
                    }
                }
            }
        }

        // 檢查"之"字
        const _z = value.split('之');
        if (_z.length > 1) {
            for (let i = 0; i < _z.length; i++) {
                let ch = '';
                if (i !== 0) {
                    // 【之】後一個字不可為【一】~【十】
                    ch = _z[i].substr(0, 1);
                    if (cNum1.indexOf(ch) > -1) {
                        result.msg.push(
                            '地址『之』前後不可接【一】~【十】'
                        );
                        break;
                    }
                }

                if (i < _z.length - 1) {
                    // 【之】前一個字不可為【一】~【十】
                    ch = _z[i].substr(_z[i].length - 1);
                    if (cNum1.indexOf(ch) > -1) {
                        result.msg.push(
                            '地址『之』前後不可接【一】~【十】'
                        );
                        break;
                    }
                }
            }
        }
        // 檢查"室"字
        const _s = value.split('室');
        if (_s.length > 1) {
            for (let i = 0; i < _s.length; i++) {
                let ch = '';

                if (i < _s.length - 1) {
                    // 【之】前一個字不可為【一】~【十】
                    ch = _s[i].substr(_s[i].length - 1);
                    if (cNum1.indexOf(ch) > -1) {
                        result.msg.push(
                            '地址『室』前不可輸入【一】~【十】'
                        );
                        break;
                    }
                }
            }
        }

        // 8.應有門牌號碼
        if (!data[14] || data[14].length === 1) {
            result.msg.push('請輸入門牌號碼');
        }

        // 9.地址不可為郵政信箱,但排除郵政路、郵局路、郵政街、郵局街
        if (value.indexOf('郵政') !== -1 || value.indexOf('郵局') !== -1) {
            if (
                value.indexOf('郵政路') !== -1 ||
                value.indexOf('郵局路') !== -1 ||
                value.indexOf('郵政街') !== -1 ||
                value.indexOf('郵局街') !== -1
            ) {
                // result.msg += '';
            } else {
                result.msg.push('地址不得為郵政信箱');
            }
        }
        // 10.過濾特殊符號
        const chEn = /^[^0-9-\u4e00-\u9fa5]+$/;

        if (value.search(chEn) > -1) {
            result.msg.push('地址請勿使用特殊符號');
        }
    }
    // if (!result.msg) result.success = true;
    if (result.msg.length <= 0) result.success = true;
    return result;
}

// 全形、半形轉換用的對應表
var HalfshapeString =
    '0123456789' +
    'abcdefghijklmnopqrstuvwxyz' +
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
    ' -~!@#$%^&*()_+`={}[]|<>?,./:;"\'\\';
var FullShapeString =
    '０１２３４５６７８９' +
    'ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ' +
    'ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ' +
    '　－－！＠＃＄％?＆＊（）＿＋‘＝｛｝【】｜＜＞？，．／：；〝’＼';
// 半形轉全形
function HalfshapeToFullshape(strSource) {
    var result = '';
    var searchIndex = -1;
    for (var i = 0; i < strSource.length; i++) {
        searchIndex = HalfshapeString.indexOf(strSource.charAt(i));
        result +=
            searchIndex !== -1
                ? FullShapeString.charAt(searchIndex)
                : strSource.charAt(i);
    }
    return result;
}

// 全形轉半形

// function FullshapeToHalfshape(strSource) {
//     var result = '',
//         searchIndex = -1;

//     for (var i = 0; i < strSource.length; i++) {
//         searchIndex = FullShapeString.indexOf(strSource.charAt(i));
//         result +=
//             searchIndex !== -1
//                 ? HalfshapeString.charAt(searchIndex)
//                 : strSource.charAt(i);
//     }
//     return result;
// }
export { checkAddress };
